.flexContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}

.flexItem {
    flex: 1;
    justify-content: center;
    align-items: center;
}

.flexItem11 {
    flex: 11;
    justify-content: center;
    align-items: center;
}

.flexItem1 {
    flex: 1;
    justify-content: center;
    align-items: center;
}

.tab {
    padding: 8px;
    cursor: pointer;
    background-color: #F2F4F6;
    font-size: 12px;
    text-align: center;
    color: #24292E;
}

.tabcontainer {
    padding: 4px;
    background-color: #F2F4F6;
    border-radius: 8px;
    margin-bottom: 30px;
    margin-top: 30px;
}

.tabactive {
    background-color: white;
    -webkit-transition: background-color 300ms linear;
    -ms-transition: background-color 300ms linear;
    transition: background-color 300ms linear;
    border-radius: 8px;
}

.item {
    font-size: 12px;
    margin-bottom: 16px;
    border-radius: 8px;
    padding: 10px;
    border: 2px #F2F4F6 solid;
    color: #24292E;
}

.extensionLabel {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    text-align: cetner;
    color: #24272A;
}

.notice {
    font-size: 12px;
    margin-left: 10px;
    margin-right: 10px;
    color: grey;
}

.button {
    margin-top: 41.5px;
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 20px;
    background: #037DD6;
    border-radius: 32px;
    color: white;
    border: 0;
    font-size: 14px;
    cursor: pointer;
}

.backdrop {
    visibility: visible;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 99998;
    background: rgba(0, 0, 0, 0.87);
    opacity: 0.3;
}

.modal {
    visibility: visible;
    position: fixed;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;
    background: white;
    padding: 20px;
    border-radius: 8px;
    top: 50%;
    max-width: 100%;
    width: 460px;
    min-width: 300px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;
    -webkit-font-smoothing: antialiased;
}

.closeButton {
    color: #BBC0C5;
    cursor: pointer;
}

.logoContainer {
    margin-left: 24px;
    margin-right: 24px;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.connectMobileText {
    font-size: 14px;
    color: black;
    margin-top: 28px;
    margin-bottom: 28px;
    line-height: 2;
}

.blue {
    color: #037DD6;
    font-weight: 700;
}

.installExtensionText {
    margin-left: 10px;
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.right {
    display: flex;
    align-items: center;
    justify-content: right;
}

#sdk-mm-qrcode {
    svg {
        width: 50%;
    }
}